import * as React from 'react';
import { connect } from 'react-redux';

import {getVideoOptions} from '../reducers/bookmakerOptions';

import VideoOptionsPresentation from '../presentations/VideoOptions/VideoOptionsPresentation';

const mapStateTopProps = (state:any) => ({
  videoOptions: getVideoOptions(state)
});

export default connect(mapStateTopProps)(VideoOptionsPresentation);
